<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    document.title = '信达能源建筑用能监管平台'

    // getAllDictItems().then(res => {
    //   try {
    //     if (res.code == 200 && res.result) {
    //       this.$ls.set('UI_CACHE_DB_DICT_DATA', res.result)
    //     }
    //   } catch (error) {

    //   }
    // })
  },
  mounted() {
    this.htmlFontSize()
    // 监听屏幕变化
    window.addEventListener('resize', () => {
      this.htmlFontSize()
    })
  },
  methods: {
    htmlFontSize() {
      this.$nextTick(() => {
        // 获取当前屏幕宽度 / 1920设计图宽度 拿到一份的px值
        if (document.documentElement.clientWidth || document.body.clientWidth) {
          let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
          let fontSize = htmlWidth / 1920
          // 设置最大和最小缩放比例
          const maxScale = 1.2;   // 最大放大到 1.3 倍
          const minScale = 0.6;   // 最小缩小到 0.8 倍

          // 先限制最小值，再限制最大值
          fontSize = Math.min(Math.max(fontSize, minScale), maxScale);
          // 赋值给html fontsize大小，页面中使用rem代替px实现响应式
          document.documentElement.style.fontSize = fontSize + 'px'
        }
      })
    }
  }
}
</script>

<style src="@/style/table.less" lang="less" scoped></style>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  scrollbar-width: 5px;
  /* Firefox */
  // -ms-overflow-style: none;

  // /* IE 10+ */
  // ::-webkit-scrollbar {
  //   display: none;
  //   /* Chrome Safari */
  // }

  font-family: SimHei;

  ::-webkit-scrollbar-button {
    display: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background: #124967;

  }

  ::-webkit-scrollbar-track {
    background: #124967;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #31A5DC;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #49FFF1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:active {
    background: #49FFF1;
    border-radius: 10px;
  }



  /* 父元素具有固定高度和水平滚动 */
  .scrollbar-container {
    height: 100px;
    overflow-x: scroll;
  }


  ::-webkit-scrollbar-thumb:horizontal {
    color: #333;
    box-shadow: 0 0 2px #ccc;
  }
}










html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  line-height: normal !important;

  .userPopover {
    .ant-popover-content {
      background: #4C4C4C;
      border-radius: 5px;

      .ant-popover-arrow {
        border-color: #4C4C4C;
      }
    }

    .ant-popover-inner {
      background: transparent;
    }
  }



  .errorUserPopover {
    width: 200px;

    .ant-popover-content {
      background: #0B4062;
      border-radius: 5px;

      .popoverContent {
        color: #fff;
        font-weight: 600;
      }

      .ant-popover-arrow {
        border-color: #0B4062;
      }
    }

    .ant-popover-title {
      border-bottom-color: #40B6F4;
    }

    .ant-popover-inner {
      background: transparent;
    }
  }

}




#app {
  width: 100%;
  height: 100%;
  min-width: 1350px !important;
  min-height: 800px !important;
}
</style>
